export default "__VITE_ASSET__uzCNU5Wr__"